export { default as PdfViewer } from './pdf-viewer.component';
export * from './pdf-viewer.component';